module.exports = __webpack_public_path__ + "img/kw-background.02ba603.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/backgrounds/kw-background.png
// module id = +QUJ
// module chunks = 57